package ru.villawonka.app.data.entity.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import ru.villawonka.app.domain.model.CountryDomain

@Serializable
enum class CountryDto {
    @SerialName("ID") INDONESIA,
    @SerialName("VN") VIETNAM,
    @SerialName("TH") THAILAND
}

fun CountryDto.toDomain() = when (this) {
    CountryDto.VIETNAM -> CountryDomain.VIETNAM
    CountryDto.THAILAND -> CountryDomain.THAILAND
    CountryDto.INDONESIA -> CountryDomain.INDONESIA
}